import { jsx } from "react/jsx-runtime";
import { useState, useRef, useCallback, useEffect } from "react";
import { ScrollbarWrapper, ScrollbarControl } from "./custom-scrollbar.styles.js";
import "@mui/material/styles";
const CustomScrollbar = ({ containerRef, offset = 0 }) => {
  var _a;
  const [isDragging, setIsDragging] = useState(false);
  const [initialPosition, setInitialPosition] = useState(0);
  const [currentPosition, setCurrentPosition] = useState(0);
  const [, setContainerPosition] = useState((containerRef == null ? void 0 : containerRef.scrollLeft) ?? 0);
  const scrollbarRef = useRef(null);
  const scrollbarControlRef = useRef(null);
  const buttonWidth = (((_a = scrollbarRef == null ? void 0 : scrollbarRef.current) == null ? void 0 : _a.offsetWidth) ?? 0) / ((containerRef == null ? void 0 : containerRef.scrollWidth) ?? 1) * 100;
  const hideScrollbar = Math.round(buttonWidth) === 100;
  const handleMouseDown = useCallback((event) => {
    event.stopPropagation();
    event.preventDefault();
    setIsDragging(true);
    setInitialPosition(event.clientX);
  }, []);
  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
    setInitialPosition(0);
  }, []);
  const handleMouseMove = useCallback(
    (event) => {
      var _a2;
      const position = (event.clientX - initialPosition) / (((_a2 = scrollbarRef == null ? void 0 : scrollbarRef.current) == null ? void 0 : _a2.offsetWidth) ?? 1) * 100;
      if (containerRef && isDragging)
        setCurrentPosition(position);
    },
    [containerRef, initialPosition, isDragging]
  );
  const handleContainerScroll = useCallback(
    (event) => {
      if (!isDragging) {
        const element = event == null ? void 0 : event.target;
        setContainerPosition((element == null ? void 0 : element.scrollLeft) ?? 0);
      }
    },
    [isDragging, containerRef]
  );
  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);
  useEffect(() => {
    if (isDragging) {
      containerRef == null ? void 0 : containerRef.scrollBy({
        left: currentPosition
      });
    }
  }, [currentPosition]);
  useEffect(() => {
    if (hideScrollbar) {
      containerRef == null ? void 0 : containerRef.removeEventListener("scroll", handleContainerScroll);
    } else {
      containerRef == null ? void 0 : containerRef.addEventListener("scroll", handleContainerScroll);
    }
    return () => {
      containerRef == null ? void 0 : containerRef.removeEventListener("scroll", handleContainerScroll);
    };
  }, [containerRef, hideScrollbar, isDragging]);
  useEffect(() => {
    if (containerRef)
      setCurrentPosition(containerRef.scrollLeft);
  }, [containerRef]);
  const left = ((containerRef == null ? void 0 : containerRef.scrollLeft) ?? 0) / ((containerRef == null ? void 0 : containerRef.scrollWidth) ?? 1) * 100;
  if (hideScrollbar)
    return null;
  return /* @__PURE__ */ jsx(ScrollbarWrapper, { offset, ref: scrollbarRef, children: /* @__PURE__ */ jsx(
    ScrollbarControl,
    {
      ref: scrollbarControlRef,
      onMouseDown: handleMouseDown,
      isDragging,
      style: {
        left: `${left}%`,
        width: `${buttonWidth}%`
      }
    }
  ) });
};
export {
  CustomScrollbar
};
